<script setup lang="ts">
import { computed } from 'vue';
import ProductCard from '../ProductCard.vue';

import useGiftCard from '@/composables/useGiftCard';
import { getContext } from '@/composables/useSearch';

const { searchResult } = getContext();
const { activeGiftCard } = useGiftCard();

const products = computed(() => searchResult.value?.products || []);

const showFavoriteProducts = computed(() => (activeGiftCard.value?.giftCards?.length ?? 0) > 0);

function isFavoriteProduct(productId: string) {
  return activeGiftCard.value?.favoriteProductIds?.includes(productId) ?? false;
}
</script>

<template>
  <div
    v-if="products.length"
    class="mx-auto grid max-w-[var(--site-max-width)] grid-cols-2 gap-x-4 gap-y-6 tablet:grid-cols-4 desktop:grid-cols-6"
  >
    <product-card
      v-for="(product, index) in products"
      :key="index"
      :product="product"
      :is-favorite-product="isFavoriteProduct(product.articleNumber)"
      :show-favorite-products="showFavoriteProducts"
    />
  </div>
</template>
